/**
 * v2 Theme - Typography (Inter/Poppins scale)
 */
const typography = {
  fontFamily: "'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",

  h1: { size: 24, weight: 600, lineHeight: 1.3 },
  h2: { size: 20, weight: 600, lineHeight: 1.35 },
  h3: { size: 16, weight: 500, lineHeight: 1.4 },

  body: { size: 14, weight: 400, lineHeight: 1.5 },
  small: { size: 12, weight: 400, lineHeight: 1.45 },
};

export default typography;

